import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.26_@babel+core@7.26.9_@playwright+test@1.49.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["HomepageBanner"] */ "/vercel/path0/packages/vite-app-ts/src/app/[locale]/(home)/components/HomepageBanner.tsx");
